import { closeButton } from './hud.js';
import { uiText } from './text.js';
import './shop-modals.css';

/**
 * Fallen in a boss's dungeon (ADR 0024): what makes the fight winnable, so
 * a first defeat reads as « not yet » and not as « impossible ». Shown by
 * the client alone on the `death` it receives there, once per browser; it
 * decides nothing. No word of a group: early on, the valley is quiet, and
 * telling a lone player to find company would only discourage them.
 */

const SEEN_KEY = 'shefira.boss-defeat-tip-seen';

/** Whether this browser has shown the advice already; unreadable storage counts as not yet. */
export function bossDefeatTipSeen(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

const TIPS = [
  'Fais améliorer ton équipement chez le forgeron : chaque niveau (+3, +4…) ajoute des dégâts, de la vie ou de la défense.',
  'Prépare des potions de vie chez l’alchimiste avec les matériaux des créatures, ou achète-en au marchand, et bois-les pendant le combat.',
  'Complète le set de la région : ses pièces rares tombent sur les créatures, les élites et dans les coffres des camps.',
  'Quand le boss s’arrête, des cases s’allument au sol : sors-en avant qu’il frappe.',
];

export class BossDefeatTip {
  private readonly root: HTMLElement;
  private readonly onKeyDown = (event: KeyboardEvent): void => {
    if (event.key !== 'Escape') return;
    event.stopPropagation();
    this.close();
  };
  private closed = false;

  constructor(private readonly onClose: () => void = () => undefined) {
    try {
      localStorage.setItem(SEEN_KEY, '1');
    } catch {
      /* shown again next visit */
    }
    this.root = document.createElement('div');
    this.root.className = 'shop-modal';
    this.root.setAttribute('role', 'dialog');
    this.root.setAttribute('aria-modal', 'true');
    this.root.setAttribute('aria-label', uiText('Ce boss t’a vaincu'));

    const frame = document.createElement('section');
    frame.className = 'shop-modal__window';
    const title = document.createElement('p');
    title.className = 'shop-modal__thanks';
    title.textContent = uiText('Pas encore !');
    const lead = document.createElement('p');
    lead.className = 'shop-modal__lead';
    lead.textContent = uiText('Un boss se bat bien préparé. Avant d’y retourner :');
    const list = document.createElement('ul');
    list.className = 'shop-modal__tips';
    for (const tip of TIPS) {
      const item = document.createElement('li');
      item.textContent = uiText(tip);
      list.append(item);
    }
    const actions = document.createElement('div');
    actions.className = 'shop-modal__actions';
    const done = document.createElement('button');
    done.type = 'button';
    done.className = 'shop-modal__button';
    done.textContent = uiText('Compris');
    done.addEventListener('click', () => {
      this.close();
    });
    actions.append(done);

    frame.append(
      title,
      lead,
      list,
      actions,
      closeButton('Fermer (Échap)', () => {
        this.close();
      }),
    );
    this.root.append(frame);
    this.root.addEventListener('click', (event) => {
      if (event.target === this.root) this.close();
    });
    document.body.append(this.root);
    window.addEventListener('keydown', this.onKeyDown, true);
    done.focus();
  }

  close(): void {
    if (this.closed) return;
    this.closed = true;
    window.removeEventListener('keydown', this.onKeyDown, true);
    this.root.remove();
    this.onClose();
  }
}
